// extracted by mini-css-extract-plugin
module.exports = {"headersearchinput":"headersearchinput_headersearchinput__Hoy2o"};